module.exports = __webpack_public_path__ + "static/shauna-22e8df8068890f68ce43969da4b11e12.gif";